import type { AppTheme } from "../../useAppTheme";
import {
	SESSION_ITEMS_NAV_FILTER_LABELS,
	SESSION_ITEMS_NAV_FILTER_ORDER,
} from "./constants";
import type { SessionItemsNavFilterValue, SessionItemsNavItem } from "./types";

export const getStatusMeta = (
	status: SessionItemsNavItem["status"],
	theme: AppTheme,
) => {
	switch (status) {
		case "answered":
			return {
				icon: "check-circle-outline",
				label: "Answered",
				color: theme.colors.primary,
			};
		case "correct":
			return {
				icon: "check",
				label: "Correct",
				color: theme.palette.success.main,
			};
		case "incorrect":
			return {
				icon: "close",
				label: "Incorrect",
				color: theme.colors.error,
			};
		case "skipped":
			return {
				icon: "minus-circle-outline",
				label: "Skipped",
				color: theme.colors.onSurfaceVariant,
			};
		default:
			return {
				icon: "eye-off-outline",
				label: "Not seen",
				color: theme.colors.onSurfaceVariant,
			};
	}
};

export const getFilterIcon = (filter: SessionItemsNavFilterValue) => {
	switch (filter) {
		case "correct":
		case "answered":
			return "check";
		case "incorrect":
			return "close";
		case "skipped":
			return "minus-circle-outline";
		case "unanswered":
			return "eye-off-outline";
		case "marked":
			return "flag";
		default:
			return "circle-outline";
	}
};

export const getSessionItemsNavFilters = (
	filters?: SessionItemsNavFilterValue[],
) => {
	const filterValues = filters?.length
		? filters
		: SESSION_ITEMS_NAV_FILTER_ORDER;

	return filterValues.map((value) => ({
		value,
		label: SESSION_ITEMS_NAV_FILTER_LABELS[value],
	}));
};

export const matchesSessionItemsNavFilter = (
	item: SessionItemsNavItem,
	filter: SessionItemsNavFilterValue,
) => {
	switch (filter) {
		case "correct":
			return item.status === "correct";
		case "incorrect":
			return item.status === "incorrect" || item.status === "skipped";
		case "skipped":
			return item.status === "skipped";
		case "marked":
			return Boolean(item.isMarked);
		case "answered":
			return item.status === "answered";
		case "unanswered":
			return item.status === "unanswered";
		default:
			return false;
	}
};

export const filterSessionItems = (
	items: SessionItemsNavItem[],
	selectedFilters: SessionItemsNavFilterValue[],
) => {
	if (!selectedFilters.length) {
		return items;
	}

	return items.filter((item) =>
		selectedFilters.some((filter) =>
			matchesSessionItemsNavFilter(item, filter),
		),
	);
};
